import colors from "../../../constants/colors";

const styles = (theme, level) => {
  return {
    root: {
      width: "80%",
      align: "center",
      "border-radius": "10px",
      overflow: "hidden",
      "margin-left": "10%",
      "margin-right": "10%",
      [theme.breakpoints.down("sm")]: {
        "margin-top": "20vh",
      },
      [theme.breakpoints.up("sm")]: {
        "margin-top": "25vh",
      },
      [theme.breakpoints.up("lg")]: {
        "margin-top": "25vh",
        height: "35%",
      },
      "margin-bottom": "10%",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    header: {
      "text-align": "center",
      "font-weight": "bold",
      "font-size": "25px",
      "font-family": "Montserrat",
    },
    scroll: {
      flex: 1,
      "overflow-y": "scroll",
      "overflow-x": "hidden",
      width: "100%",
      height: "100%",
    },
    box: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    label: {
      "white-space": "nowrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: 13,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 15,
      },
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    imageList: {
      width: "80%",
      height: "80%",
    },
    chip: {
      "font-weight": "bold",
      "font-size": "12px",
      "font-family": "Montserrat",
      color: colors.black,
      maxWidth: "250px",
      marginLeft: 4,
      marginRight: 4,
    },
    texts: {
      "font-weight": "bold",
      "font-family": "Montserrat",
    },
    avatar: {
      width: "10%",
    },
    name: {
      width: "30%",
    },
    price: {
      width: "20%",
    },
    amount: {
      width: "20%",
    },
  };
};

export default styles;
